import React from 'react';
import '../styles/globals.css';
import { abstractTestnet, abstract } from "wagmi/chains";
import { NETWORK } from '../src/contract/utils/consts';
import { AbstractWalletProvider } from '@abstract-foundation/agw-react';
import { NootLadderContractProvider } from '../src/contract/webhookContext';
import Layout from '../src/Components/Layout';
import Head from 'next/head';

const activeChain = NETWORK === "mainnet" ? abstract : abstractTestnet;

function MyApp({ Component, pageProps }) {
  return (
    <>
      <Head>
        <title>NOOT Card Game</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <React.StrictMode>
        <AbstractWalletProvider
          chain={activeChain}
        >
          <NootLadderContractProvider>
            <Layout>
              <Component {...pageProps} />
            </Layout>
          </NootLadderContractProvider>
        </AbstractWalletProvider>
      </React.StrictMode>
    </>
  );
}

export default MyApp; 